<template>
    
    <div>

        <HomeTopNavbar v-if="!isDefaultPath" />
    
        <router-view></router-view>

        <RuleDialog 
            v-if="openDialog"
        />
    </div>
</template>

<script>

    import { 
        reactive, 
        toRefs, 
        getCurrentInstance,
        onMounted,
        computed 
    } from "vue";
    import jquery from "jquery";
    import { useRoute } from "vue-router";

    import HomeTopNavbar from "@/components/home-top-navbar";
    import RuleDialog from "@/components/rule-dialog";

    export default {
        name: "Index",
        components: {
            HomeTopNavbar,
            RuleDialog
        },
        setup() {

            const _this = getCurrentInstance().appContext.config.globalProperties;
            const route = useRoute();

            const state = reactive({
                openDialog: false
            });

            onMounted(() => {

                registerListeners();

                recordBrowseData();
            });

            const isDefaultPath = computed(() => {

                const { path } = route;

                return path === "/";
            })

            const registerListeners = () => {

                _this.$bus.$on(_this.$constants.EVENT.RULE_DIALOG, ({ type }) => {
                    state.openDialog = type === _this.$constants.ENUM.RULE_DIALOG.OPEN;
                });
            };

            const getUrlParam = (name) => {

                const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');

                const r = window.location.search.substr(1).match(reg);

                return r? unescape(r[2]) : "";
            };

            const recordBrowseData = () => {

                const jssdkUrl = `https://m.21jingji.com/wechat/jssdk/?url=${encodeURIComponent(window.location.href)}`;

                const script = document.createElement("script");

                script.src = jssdkUrl;

                document.body.appendChild(script);

                window.wx.ready(() => {

                    const params = {
                        title: process.env.VUE_APP_SHARE_TITLE,
                        desc: "25年，香港正青春。情系香江，共谱新篇。",
                        imgUrl: "https://s3.bmp.ovh/imgs/2022/06/28/a2631b31884cf116.jpg",
                        link: document.location.href
                    };

                    window.wx.updateAppMessageShareData(params);

                    window.wx.updateTimelineShareData(params);
                });

                const url = "https://stats.21jingji.com/behavior/log";
                const referrer = encodeURIComponent(document.referrer);
                const from = getUrlParam("from");
                const rand = Math.random();

                const datas = {
                    id: "herald_484637",
                    catid: 750,
                    subcat: 810,
                    platform: "web",
                    uid: "",
                    referrer,
                    rand,
                    from
                };
                
                jquery.ajax({
                    type: "POST",
                    url,
                    dataType: 'jsonp',
                    jsonp: 'callback',
                    data: {
                        type: 1,
                        datas
                    }
                });
            };

            return {
                ...toRefs(state),
                isDefaultPath
            };
        }
    }
</script>